import Loader from 'Component/Loader';
import { WishlistSharedPage as SourceWishlistSharedPage } from 'SourceRoute/WishlistSharedPage/WishlistSharedPage.component';

import './WishlistSharedPage.override.style.scss';
/** @namespace Pwa/Route/WishlistSharedPage/Component */
export class WishlistSharedPage extends SourceWishlistSharedPage {
    renderCreatorsInfo() {
        const { creatorsName } = this.props;

        return (
            <h2 block="WishlistSharedPage" elem="CreatorsInfo">
                {__('Wishlist shared by ')}
                <strong>{creatorsName}</strong>
            </h2>
        );
    }

    renderContent() {
        const { wishlistItems, isWishlistLoading, isWishlistEmpty, isLoading } = this.props;

        if (isWishlistEmpty && !isWishlistLoading) {
            return this.renderNoProductsFound();
        }

        return (
            <div block="WishlistSharedPage" elem="Products">
                <Loader isLoading={isLoading} />
                {this.renderProducts(wishlistItems)}
            </div>
        );
    }
}

export default WishlistSharedPage;
